
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match/[match_id]/teams_score",
      function () {
        return require("private-next-pages/match/[match_id]/teams_score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match/[match_id]/teams_score"])
      });
    }
  